"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3869],{

/***/ 83869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D4": function() { return /* binding */ canViewStoryToonEpisode; },
/* harmony export */   "Hi": function() { return /* binding */ fetchStoryToonEpisode; },
/* harmony export */   "Rh": function() { return /* binding */ fetchStoryToons; },
/* harmony export */   "hs": function() { return /* binding */ fetchStoryToon; },
/* harmony export */   "rM": function() { return /* binding */ fetchStoryToonEpisodesInStoryOrder; }
/* harmony export */ });
/* unused harmony exports fetchStoryToonEpisodes, sortStoryToonEpisodesByOriginalOrder */
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79825);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39819);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45874);
/* harmony import */ var _utils_webtoon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23043);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39322);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};





var STORY_TOON_ENDPOINT = "/story-toons";
var STORY_TOON_REQUEST_TIMEOUT = 8000;
var withStoryToonTimeout = function() {
    var _ref = _asyncToGenerator(function(request) {
        var timeoutId, timeout;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    timeout = new Promise(function(_, reject) {
                        timeoutId = setTimeout(function() {
                            return reject(new Error("StoryToon request timed out"));
                        }, STORY_TOON_REQUEST_TIMEOUT);
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    return [
                        4,
                        Promise.race([
                            request,
                            timeout
                        ])
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    if (timeoutId) {
                        clearTimeout(timeoutId);
                    }
                    return [
                        7
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function withStoryToonTimeout(request) {
        return _ref.apply(this, arguments);
    };
}();
var normalizeList = function(data) {
    return Array.isArray(data) ? data : data.items;
};
var isNotFoundError = function(error) {
    var ref;
    return axios__WEBPACK_IMPORTED_MODULE_0___default().isAxiosError(error) && ((ref = error.response) === null || ref === void 0 ? void 0 : ref.status) === 404;
};
var ref;
var isUnavailableStoryToonListError = function(error) {
    var ref1;
    return axios__WEBPACK_IMPORTED_MODULE_0___default().isAxiosError(error) && [
        400,
        404
    ].includes((ref = (ref1 = error.response) === null || ref1 === void 0 ? void 0 : ref1.status) !== null && ref !== void 0 ? ref : 0);
};
var fetchStoryToons = function() {
    var _ref = _asyncToGenerator(function() {
        var response, storyToons, error, response1, fallbackError;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        withStoryToonTimeout(___WEBPACK_IMPORTED_MODULE_4__/* .api.get */ .hi.get("".concat(STORY_TOON_ENDPOINT, "/")))
                    ];
                case 1:
                    response = _state.sent();
                    storyToons = normalizeList(response.data);
                    if (storyToons.length) {
                        return [
                            2,
                            storyToons
                        ];
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    if (!isUnavailableStoryToonListError(error)) {
                        throw error;
                    }
                    return [
                        3,
                        3
                    ];
                case 3:
                    _state.trys.push([
                        3,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        withStoryToonTimeout(___WEBPACK_IMPORTED_MODULE_4__/* .api.get */ .hi.get("".concat(STORY_TOON_ENDPOINT, "/").concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .toQueryString */ .UK)({
                            storyToonIds: _constants__WEBPACK_IMPORTED_MODULE_1__/* .WEBTOON_STORY_TOON_IDS.join */ .FA.join(",")
                        }))))
                    ];
                case 4:
                    response1 = _state.sent();
                    return [
                        2,
                        normalizeList(response1.data)
                    ];
                case 5:
                    fallbackError = _state.sent();
                    if (isUnavailableStoryToonListError(fallbackError)) {
                        return [
                            2,
                            []
                        ];
                    }
                    throw fallbackError;
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchStoryToons() {
        return _ref.apply(this, arguments);
    };
}();
var fetchStoryToon = function() {
    var _ref = _asyncToGenerator(function(webtoonId) {
        var data, error, storyToons, storyToon;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        4
                    ]);
                    return [
                        4,
                        withStoryToonTimeout(___WEBPACK_IMPORTED_MODULE_4__/* .api.get */ .hi.get("".concat(STORY_TOON_ENDPOINT, "/").concat(webtoonId, "/")))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
                case 2:
                    error = _state.sent();
                    if (!isNotFoundError(error)) {
                        throw error;
                    }
                    return [
                        4,
                        fetchStoryToons().catch(function() {
                            return [];
                        })
                    ];
                case 3:
                    storyToons = _state.sent();
                    storyToon = storyToons.find(function(item) {
                        var ref;
                        return (0,_utils_webtoon__WEBPACK_IMPORTED_MODULE_3__/* .getStoryToonId */ .E6)(item) === webtoonId || item.storyId === webtoonId || ((ref = item.story) === null || ref === void 0 ? void 0 : ref.id) === webtoonId;
                    });
                    if (!storyToon) {
                        throw error;
                    }
                    return [
                        2,
                        storyToon
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchStoryToon(webtoonId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchStoryToonEpisodes = function() {
    var _ref = _asyncToGenerator(function(storyToonId) {
        var ordering, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    ordering = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "oldest";
                    return [
                        4,
                        withStoryToonTimeout(___WEBPACK_IMPORTED_MODULE_4__/* .api.get */ .hi.get("".concat(STORY_TOON_ENDPOINT, "/").concat(storyToonId, "/episodes/").concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .toQueryString */ .UK)({
                            ordering: ordering,
                            page: 1,
                            perPage: _constants__WEBPACK_IMPORTED_MODULE_1__/* .WEBTOON_EPISODE_LIST_LIMIT */ .xi
                        }))))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        normalizeList(data)
                    ];
            }
        });
    });
    return function fetchStoryToonEpisodes(storyToonId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchOriginalEpisodes = function() {
    var _ref = _asyncToGenerator(function(storyId) {
        var fetchPage, firstPage, remainingPages;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    fetchPage = function() {
                        var _ref = _asyncToGenerator(function(page) {
                            var data;
                            return __generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            withStoryToonTimeout(___WEBPACK_IMPORTED_MODULE_4__/* .api.get */ .hi.get("/stories/".concat(storyId, "/episodes/").concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .toQueryString */ .UK)({
                                                ordering: "oldest",
                                                page: page,
                                                perPage: _constants__WEBPACK_IMPORTED_MODULE_1__/* .WEBTOON_EPISODE_LIST_LIMIT */ .xi
                                            }))))
                                        ];
                                    case 1:
                                        data = _state.sent().data;
                                        return [
                                            2,
                                            data
                                        ];
                                }
                            });
                        });
                        return function fetchPage(page) {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    return [
                        4,
                        fetchPage(1)
                    ];
                case 1:
                    firstPage = _state.sent();
                    return [
                        4,
                        Promise.all(Array.from({
                            length: Math.max(firstPage.pages - 1, 0)
                        }, function(_, index) {
                            return fetchPage(index + 2);
                        }))
                    ];
                case 2:
                    remainingPages = _state.sent();
                    return [
                        2,
                        [
                            firstPage
                        ].concat(_toConsumableArray(remainingPages)).flatMap(function(page) {
                            return page.items;
                        })
                    ];
            }
        });
    });
    return function fetchOriginalEpisodes(storyId) {
        return _ref.apply(this, arguments);
    };
}();
var sortStoryToonEpisodesByOriginalOrder = function(storyToonEpisodes, originalEpisodes) {
    var ordering = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "oldest";
    var originalEpisodeById = new Map(originalEpisodes.map(function(episode, index) {
        return [
            episode.id,
            {
                episode: episode,
                index: index
            }
        ];
    }));
    var sortedEpisodes = storyToonEpisodes.map(function(episode, index) {
        return {
            episode: episode,
            fallbackOrder: index,
            originalEpisode: typeof episode.episodeId === "number" ? originalEpisodeById.get(episode.episodeId) : undefined
        };
    }).sort(function(a, b) {
        if (a.originalEpisode === undefined && b.originalEpisode === undefined) {
            return a.fallbackOrder - b.fallbackOrder;
        }
        if (a.originalEpisode === undefined) {
            return 1;
        }
        if (b.originalEpisode === undefined) {
            return -1;
        }
        return a.originalEpisode.index - b.originalEpisode.index;
    }).map(function(param, index) {
        var episode = param.episode, originalEpisode = param.originalEpisode;
        return _objectSpreadProps(_objectSpread({}, episode), {
            episodeNumber: index + 1,
            isFree: originalEpisode === null || originalEpisode === void 0 ? void 0 : originalEpisode.episode.isFree,
            purchaseType: originalEpisode === null || originalEpisode === void 0 ? void 0 : originalEpisode.episode.purchaseType
        });
    });
    return ordering === "newest" ? sortedEpisodes.reverse() : sortedEpisodes;
};
var canViewStoryToonEpisode = function(episode) {
    return !!episode && (episode.isFree === true || !!episode.purchaseType);
};
var fetchStoryToonEpisodesInStoryOrder = function() {
    var _ref = _asyncToGenerator(function(storyToonId, storyId) {
        var ordering, ref, storyToonEpisodes, originalEpisodes;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    ordering = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "oldest";
                    return [
                        4,
                        Promise.all([
                            fetchStoryToonEpisodes(storyToonId, "oldest"),
                            fetchOriginalEpisodes(storyId).catch(function() {
                                return [];
                            })
                        ])
                    ];
                case 1:
                    ref = _slicedToArray.apply(void 0, [
                        _state.sent(),
                        2
                    ]), storyToonEpisodes = ref[0], originalEpisodes = ref[1];
                    return [
                        2,
                        sortStoryToonEpisodesByOriginalOrder(storyToonEpisodes, originalEpisodes, ordering)
                    ];
            }
        });
    });
    return function fetchStoryToonEpisodesInStoryOrder(storyToonId, storyId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchStoryToonEpisode = function() {
    var _ref = _asyncToGenerator(function(storyToonId, storyToonEpisodeId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        withStoryToonTimeout(___WEBPACK_IMPORTED_MODULE_4__/* .api.get */ .hi.get("".concat(STORY_TOON_ENDPOINT, "/").concat(storyToonId, "/episodes/").concat(storyToonEpisodeId, "/")))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchStoryToonEpisode(storyToonId, storyToonEpisodeId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 23043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cn": function() { return /* binding */ getStoryToonEpisodeThumbnail; },
/* harmony export */   "E6": function() { return /* binding */ getStoryToonId; },
/* harmony export */   "FY": function() { return /* binding */ getStoryToonEpisodeNumber; },
/* harmony export */   "KK": function() { return /* binding */ getStoryToonAuthorName; },
/* harmony export */   "KW": function() { return /* binding */ getStoryToonTitle; },
/* harmony export */   "P": function() { return /* binding */ getWebtoonStoryMeta; },
/* harmony export */   "Pi": function() { return /* binding */ getWebtoonEpisodePath; },
/* harmony export */   "fP": function() { return /* binding */ getStoryToonEpisodeImages; },
/* harmony export */   "hC": function() { return /* binding */ getStoryToonEpisodeByNumber; },
/* harmony export */   "tm": function() { return /* binding */ getStoryToonCoverImage; },
/* harmony export */   "v$": function() { return /* binding */ getStoryToonSubtitle; },
/* harmony export */   "wk": function() { return /* binding */ parseWebtoonRouteNumber; },
/* harmony export */   "yA": function() { return /* binding */ getWebtoonStoryPath; }
/* harmony export */ });
/* unused harmony export getWebtoonEpisodeByNumber */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39819);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var getWebtoonStoryMeta = function(storyId) {
    if (!storyId) {
        return undefined;
    }
    return _constants__WEBPACK_IMPORTED_MODULE_0__/* .WEBTOON_STORIES.find */ .lV.find(function(story) {
        return story.id === storyId;
    });
};
var parseWebtoonRouteNumber = function(value) {
    var rawValue = Array.isArray(value) ? value[0] : value;
    var parsedValue = Number(rawValue);
    return Number.isSafeInteger(parsedValue) && parsedValue > 0 ? parsedValue : undefined;
};
var ref, ref1;
var getStoryToonId = function(storyToon) {
    return (ref1 = (ref = storyToon === null || storyToon === void 0 ? void 0 : storyToon.webtoonId) !== null && ref !== void 0 ? ref : storyToon === null || storyToon === void 0 ? void 0 : storyToon.storyToonId) !== null && ref1 !== void 0 ? ref1 : storyToon === null || storyToon === void 0 ? void 0 : storyToon.id;
};
var getWebtoonStoryPath = function(storyId) {
    return "/webtoon/".concat(storyId);
};
var getWebtoonEpisodePath = function(storyId, episodeNumber) {
    return "/webtoon/".concat(storyId, "/").concat(episodeNumber);
};
var getWebtoonEpisodeByNumber = function(episodes, episodeNumber) {
    if (!episodeNumber) {
        return undefined;
    }
    return episodes[episodeNumber - 1];
};
var ref2, ref3, ref4;
var getStoryToonTitle = function(storyToon, webtoonMeta) {
    var ref;
    return (ref4 = (ref3 = (ref2 = storyToon === null || storyToon === void 0 ? void 0 : storyToon.title) !== null && ref2 !== void 0 ? ref2 : storyToon === null || storyToon === void 0 ? void 0 : (ref = storyToon.story) === null || ref === void 0 ? void 0 : ref.title) !== null && ref3 !== void 0 ? ref3 : webtoonMeta === null || webtoonMeta === void 0 ? void 0 : webtoonMeta.title) !== null && ref4 !== void 0 ? ref4 : "";
};
var ref5, ref6, ref7, ref8;
var getStoryToonSubtitle = function(storyToon, webtoonMeta) {
    var ref;
    return (ref8 = (ref7 = (ref6 = (ref5 = storyToon === null || storyToon === void 0 ? void 0 : storyToon.subtitle) !== null && ref5 !== void 0 ? ref5 : storyToon === null || storyToon === void 0 ? void 0 : storyToon.summary) !== null && ref6 !== void 0 ? ref6 : storyToon === null || storyToon === void 0 ? void 0 : (ref = storyToon.story) === null || ref === void 0 ? void 0 : ref.summary) !== null && ref7 !== void 0 ? ref7 : webtoonMeta === null || webtoonMeta === void 0 ? void 0 : webtoonMeta.subtitle) !== null && ref8 !== void 0 ? ref8 : "";
};
var ref9;
var getStoryToonAuthorName = function(storyToon) {
    var ref, ref1;
    return (ref9 = storyToon === null || storyToon === void 0 ? void 0 : (ref = storyToon.story) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.nickname) !== null && ref9 !== void 0 ? ref9 : "";
};
var ref10, ref11, ref12, ref13;
var getStoryToonCoverImage = function(storyToon) {
    var ref;
    return (ref13 = (ref12 = (ref11 = (ref10 = storyToon === null || storyToon === void 0 ? void 0 : storyToon.thumbnailImage) !== null && ref10 !== void 0 ? ref10 : storyToon === null || storyToon === void 0 ? void 0 : storyToon.coverImage) !== null && ref11 !== void 0 ? ref11 : storyToon === null || storyToon === void 0 ? void 0 : storyToon.mainImage) !== null && ref12 !== void 0 ? ref12 : storyToon === null || storyToon === void 0 ? void 0 : storyToon.image) !== null && ref13 !== void 0 ? ref13 : storyToon === null || storyToon === void 0 ? void 0 : (ref = storyToon.story) === null || ref === void 0 ? void 0 : ref.coverImage;
};
var _episodeNumber, ref14, ref15;
var getStoryToonEpisodeNumber = function(episode, index) {
    return (ref15 = (ref14 = (_episodeNumber = episode.episodeNumber) !== null && _episodeNumber !== void 0 ? _episodeNumber : episode.number) !== null && ref14 !== void 0 ? ref14 : episode.order) !== null && ref15 !== void 0 ? ref15 : index + 1;
};
var getStoryToonEpisodeByNumber = function(episodes, episodeNumber) {
    if (!episodeNumber) {
        return undefined;
    }
    var ref;
    return (ref = episodes.find(function(episode, index) {
        return getStoryToonEpisodeNumber(episode, index) === episodeNumber;
    })) !== null && ref !== void 0 ? ref : episodes[episodeNumber - 1];
};
var getImageFromSlot = function(slot) {
    if (!slot) {
        return undefined;
    }
    if ("attachment" in slot) {
        return slot;
    }
    var _image;
    return (_image = slot.image) !== null && _image !== void 0 ? _image : slot.file;
};
var isStoryToonImage = function(image) {
    var ref;
    return !!(image === null || image === void 0 ? void 0 : (ref = image.attachment) === null || ref === void 0 ? void 0 : ref.url);
};
var getStoryToonEpisodeImages = function(episode) {
    var ref;
    if (!episode) {
        return [];
    }
    var ref1, _images, _episodeImages, _toonImages, _imageFiles, _contentImages, _files, _cuts, ref2, _pages, ref3;
    return _toConsumableArray((ref1 = (ref = episode.content) === null || ref === void 0 ? void 0 : ref.images) !== null && ref1 !== void 0 ? ref1 : []).concat(_toConsumableArray((_images = episode.images) !== null && _images !== void 0 ? _images : []), _toConsumableArray((_episodeImages = episode.episodeImages) !== null && _episodeImages !== void 0 ? _episodeImages : []), _toConsumableArray((_toonImages = episode.toonImages) !== null && _toonImages !== void 0 ? _toonImages : []), _toConsumableArray((_imageFiles = episode.imageFiles) !== null && _imageFiles !== void 0 ? _imageFiles : []), _toConsumableArray((_contentImages = episode.contentImages) !== null && _contentImages !== void 0 ? _contentImages : []), _toConsumableArray((_files = episode.files) !== null && _files !== void 0 ? _files : []), _toConsumableArray((ref2 = ((_cuts = episode.cuts) !== null && _cuts !== void 0 ? _cuts : []).map(getImageFromSlot)) !== null && ref2 !== void 0 ? ref2 : []), _toConsumableArray((ref3 = ((_pages = episode.pages) !== null && _pages !== void 0 ? _pages : []).map(getImageFromSlot)) !== null && ref3 !== void 0 ? ref3 : []), [
        episode.contentImage,
        episode.imageFile,
        episode.image, 
    ]).filter(isStoryToonImage);
};
var ref16;
var getStoryToonEpisodeThumbnail = function(episode) {
    return (ref16 = episode === null || episode === void 0 ? void 0 : episode.thumbnailImage) !== null && ref16 !== void 0 ? ref16 : getStoryToonEpisodeImages(episode)[0];
};


/***/ })

}]);